import React, { Fragment } from 'react';
import { defaultTemplate, withAuth } from 'core/hoc';
import { PropTypes } from 'prop-types';

const iconName = name => (name ? '' + name : '');

const BaasicButtonTemplate = function({ onClick, authorization, ...otherProps }) {
	return <AuthContent authorization={authorization} onAction={onClick} {...otherProps} />;
};

BaasicButtonTemplate.propTypes = {
	onClick: PropTypes.func,
	authorization: PropTypes.any,
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	doubleClick: PropTypes.bool,
};

const AuthContent = withAuth(DefaultContent);

function SingleClickButton({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	className,
	onAction,
	title,
	label,
	icon,
	t,
	setRef,
}) {
	return onAction ? (
		<button
			ref={button => setRef(button)}
			type={type}
			disabled={disabled}
			onClick={onAction}
			className={className}
			title={t(title) || t(label)}
		>
			{content || (
				<Fragment>
					<span className={`${iconName(icon)}`} />
					{!onlyIcon && t(label)}
				</Fragment>
			)}
		</button>
	) : null;
}

SingleClickButton.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	setRef: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
};

function DoubleClickButton({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	className,
	title,
	onAction,
	label,
	icon,
	t,
	setRef,
}) {
	return onAction ? (
		<button
			ref={button => setRef(button)}
			type={type}
			disabled={disabled}
			onDoubleClick={onAction}
			className={className}
			title={t(title) || t(label)}
		>
			{content || (
				<span>
					<span className={`${iconName(icon)}`} />
					{!onlyIcon && t(label)}
				</span>
			)}
		</button>
	) : null;
}

DoubleClickButton.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	setRef: PropTypes.func,
	onAction: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
};

function DefaultContent({
	onlyIcon = false,
	disabled = false,
	content = null,
	type = 'button',
	className,
	onAction,
	label,
	title,
	icon,
	t,
	doubleClick = false,
	setRef = () => {},
}) {
	return doubleClick ? (
		<DoubleClickButton
			onlyIcon={onlyIcon}
			disabled={disabled}
			content={content}
			type={type}
			className={className}
			onAction={onAction}
			label={label}
			icon={icon}
			title={title || label}
			t={t}
			setRef={setRef}
		/>
	) : (
		<SingleClickButton
			onlyIcon={onlyIcon}
			disabled={disabled}
			content={content}
			type={type}
			className={className}
			onAction={onAction}
			label={label}
			title={title || label}
			icon={icon}
			t={t}
			setRef={setRef}
		/>
	);
}

DefaultContent.propTypes = {
	onlyIcon: PropTypes.bool,
	disabled: PropTypes.bool,
	content: PropTypes.any,
	type: PropTypes.string,
	className: PropTypes.string,
	onAction: PropTypes.func,
	setRef: PropTypes.func,
	label: PropTypes.string,
	title: PropTypes.string,
	icon: PropTypes.string,
	t: PropTypes.func,
	doubleClick: PropTypes.bool,
};

export default defaultTemplate(BaasicButtonTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/buttons/BaasicButtonTemplate.jsx